import * as types from "../actions/actionTypes";

// Initial/cleared state is `null`: it mirrors what the API layer itself
// resolves to when a school is not present in the new backend, so every
// downstream consumer can rely on a single "no discount config" sentinel
// and use optional chaining (promozioni?.earlyPaymentDiscountSettings...)
// without needing to distinguish "not loaded yet" from "not applicable".
export default function promozioniNewReducer(state = null, action) {
  switch (action.type) {
    case types.LOAD_PROMOZIONI_NEW_SUCCESS:
      return action.promozioni;
    case types.APP_CLEAR:
      return null;
    case types.SCUOLA_CLEAR:
      return null;

    default:
      return state;
  }
}
